import NumInput from "@/components/Inputs/NumInput/NumInput.tsx";
import { ExtraProps } from "@/components/ReservationOptions/Extra/ExtraProps.ts";
import { useGetExtrasTranslated } from "@/components/ReservationOptions/hooks/useGetExtrasTranslated.ts";
import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { translateCalculationRule } from "@/helpers/translation/translateCalculationRule.ts";
import { InputType, MandatoryExtra } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const Extra = (props: ExtraProps) => {
  const getExtraTranslated = useGetExtrasTranslated();

  const { t } = useTranslation();
  const updateCartItemOptions = useEngineStore((state) => state.updateCartItemOptions);
  const extra = props.extra;

  const currValue = useMemo(() => {
    return props.cartItem.optionalExtras.find((opt) => opt.id === extra.id)?.value;
  }, [extra.id, props.cartItem.optionalExtras]);
  const initialValue = useMemo(() => {
    return props?.disabled ? (props.extra as MandatoryExtra).mandatoryQuantity : currValue;
  }, [currValue, props?.disabled, props.extra]);

  const renderExtraCheckbox = () => {
    const renderLabel = () => {
      if (props.disabled) {
        return t("added");
      } else {
        return initialValue ? t("remove") : t("select");
      }
    };

    return (
      <button
        className={!currValue ? "c-be-button" : "c-be-button c-be-button--secondary"}
        onClick={() => updateCartItemOptions({ ...extra, value: currValue ? 0 : 1 }, props.cartItem.id)}
        disabled={props.disabled}
      >
        <span className="c-be-button__label">{renderLabel()}</span>
      </button>
    );
  };
  const renderNumberInput = () => {
    return (
      <NumInput
        // key prop needed to re-render the component when the value changes (to fix resetting the value bug)
        key={currValue}
        disabled={props.disabled}
        decrementDisabled={props.disabled}
        incrementDisabled={props.disabled}
        value={initialValue}
        onChange={(value) => updateCartItemOptions({ ...extra, value }, props.cartItem.id)}
      />
    );
  };

  const { name, description } = getExtraTranslated(extra);

  return (
    <li
      key={extra.id}
      className={`option c-reservation-option ${
        props.extra.__typename === "MandatoryExtra" ? "c-reservation-option--mandatory" : ""
      }`}
    >
      <div className="c-reservation-option__left">
        <p className="c-reservation-option__title u-p1">{name}</p>
        {description && <p className="c-reservation-option__description u-p2">{description}</p>}
      </div>
      <div className="c-reservation-option__center">
        <p className="u-h6 u-fw-600">{formatCurrency(extra.price)}</p>
        <p className="u-p1 ">{translateCalculationRule(extra.calculationRule)}</p>
      </div>
      <div className="c-reservation-option__right">
        {extra.inputType === InputType.NumberSelect ? renderNumberInput() : renderExtraCheckbox()}
      </div>
    </li>
  );
};
